<app-base-cheque-payments
[getTableDataApiMethodName]="getTableDataApiMethodName"
[pageTitle]="pageTitle"
>
</app-base-cheque-payments>
